import { render, staticRenderFns } from "./ContractorAboutForAdmin.vue?vue&type=template&id=1c926166"
import script from "./ContractorAboutForAdmin.vue?vue&type=script&lang=ts"
export * from "./ContractorAboutForAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c926166')) {
      api.createRecord('1c926166', component.options)
    } else {
      api.reload('1c926166', component.options)
    }
    module.hot.accept("./ContractorAboutForAdmin.vue?vue&type=template&id=1c926166", function () {
      api.rerender('1c926166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ContractorAboutForAdmin.vue"
export default component.exports